import React from 'react'
import './App.css'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import VideoPlayerWrapper from './components/VideoPlayer'

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<></>} />
        <Route path='/zoom' element={<VideoPlayerWrapper />} />
      </Routes>
    </Router>
  );
}

export default App;
